import { GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_CMS_SIMPLIFIED } from 'getting-started-shared-tasks/onboardingKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
// @ts-expect-error not yet typed
import { laboratory } from '../utils/laboratoryUtils'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { getAiOnboardingPath, HubletUrl } from '../utils/urls';
export const getAiOnboardingExperimentRedirectPath = portalId => {
  return laboratory({
    portalId,
    treatmentKey: 'csfe-013',
    parameterKey: 'group',
    redirectOptions: {
      control: {
        url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
        view: ONBOARDING_VIEWS.CMS,
        onboardingKey: ONBOARDING_CMS_SIMPLIFIED,
        groupKey: GROUP_KEYS.cmsV3
      },
      variant: {
        url: getAiOnboardingPath(portalId),
        view: ONBOARDING_VIEWS.CMS,
        onboardingKey: ONBOARDING_CMS_SIMPLIFIED,
        groupKey: GROUP_KEYS.cmsV3
      }
    }
  });
};